import { appOpened } from '../app/app.slice';
import { startListening } from '../listenerMiddleware';
import {
  updateMarketingMeta,
  pushMarketingMetaHistoryItem,
} from './marketingMeta.slice';

startListening({
  actionCreator: appOpened,
  effect: (_, { dispatch }) => {
    dispatch(updateMarketingMeta());
  },
});

startListening({
  actionCreator: updateMarketingMeta.fulfilled,
  effect: (action, { dispatch }) => {
    if (Object.keys(action.payload).length > 0) {
      dispatch(pushMarketingMetaHistoryItem(action.payload));
    }
  },
});
